export enum AspectCode {
  Accounting = "acc",
  AIBookkeeper = "aib",
  AdvancedLedger = "adv",
  AskDigits = "ask",
  AskDigitsAgent = "agi",
  Audit = "adt",
  AutomatedBankRecs = "abr",
  AutomatedReceiptHandling = "arh",
  BanksAndCards = "bnc",
  Branding = "bnd",
  CategoryManager = "cmg",
  ClosedPeriod = "clp",
  Connections = "cnx",
  CustomerDirectory = "cdr",
  DimensionManager = "dmg",
  Employments = "emp",
  Finch = "fnc",
  Financials = "fin",
  FirmLevelPredictions = "flp",
  Collect = "gpd", // Formerly Get Paid
  Home = "hom",
  Invoicing = "inv",
  PayBills = "pbl",
  QuarterlyDashboard = "qtr",
  Reports = "rpt",
  RestrictLedgerEdits = "rle",
  Sharing = "shr",
  TransactionActionItems = "tai",
  Upsells = "ups",
  Vault = "vlt",
  VendorDirectory = "vdr",
}
